export const features = [
  {
    icon: "ri-4k-line",
    title: "超高清画质",
    description: "支持4K超清画质播放，搭配HDR技术，呈现细腻逼真的视觉体验，让每一个画面都栩栩如生。",
  },
  {
    icon: "ri-speed-up-line",
    title: "极速加载",
    description: "采用全球CDN加速节点，智能码率自适应技术，确保流畅播放不卡顿，秒开视频无需等待。",
  },
  {
    icon: "ri-smartphone-line",
    title: "多端同步",
    description: "支持手机、平板、电脑、智能电视等多终端无缝切换，观看记录云端同步，随时随地续看。",
  },
  {
    icon: "ri-translate-2",
    title: "多语言字幕",
    description: "内置智能字幕系统，支持中英日韩等多国语言字幕，AI实时翻译，追剧无障碍。",
  },
  {
    icon: "ri-download-cloud-2-line",
    title: "离线下载",
    description: "支持高清视频离线缓存下载，无网络也能畅快观看，通勤旅途好伴侣。",
  },
  {
    icon: "ri-shield-check-line",
    title: "安全纯净",
    description: "无广告纯净观影体验，严格内容审核机制，绿色安全，全家人放心使用。",
  },
];

export const stats = [
  { value: "5000万+", label: "月活跃用户" },
  { value: "10万+", label: "影视资源" },
  { value: "200+", label: "覆盖国家地区" },
  { value: "99.9%", label: "服务可用率" },
];